module.exports = __webpack_public_path__ + "js/0.6a634cd8.worker.js"